import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { action } from 'mobx';
import DeviceCollection from '../device/DeviceCollection';
let InterfacesDeviceCollection = (_class = class InterfacesDeviceCollection extends DeviceCollection {
  fetch() {
    // For now, we want to exclude cloud devices from IC, eventually we may want to change this
    return super.fetch({
      query: {
        filterCloud: true
      }
    });
  }
  getFilterValues(model) {
    // @ts-expect-error not very good type safety here
    return ['device_name'].map(name => model[name] || model.get(name));
  }
  get secondarySort() {
    return {
      field: 'interfaceCount',
      direction: 'desc'
    };
  }
  get defaultSortState() {
    return {
      field: 'percentMatched',
      direction: 'desc'
    };
  }
  updateDeviceInterfaceMatchData(deviceMatches) {
    const deviceIds = Object.keys(deviceMatches);
    for (let i = 0; i < deviceIds.length; i++) {
      const key = deviceIds[i];
      const matchInfo = deviceMatches[key];
      if (matchInfo) {
        const model = this.get(key);
        if (model) {
          model.set({
            loadingInterfaceResults: false,
            ...matchInfo
          });
        }
      }
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "updateDeviceInterfaceMatchData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateDeviceInterfaceMatchData"), _class.prototype), _class);
export default InterfacesDeviceCollection;